import React, { useState } from "react";
import Collapse from "react-collapse";

export function BookingFormTipsSection({ buttonText, content }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="views-section">
      <span
        role="button"
        className="link pointer views-modal-link"
        onClick={() => setIsOpen(!isOpen)}
      >
        {buttonText}
      </span>
      <Collapse isOpened={isOpen}>
        <div className="views-modal-section-content">{content}</div>
      </Collapse>
    </div>
  );
}
